// import ImageSection from "../../components/Login/ImageSection";
import SignInForm from "../../components/Login/SignInFormLandLoad";
import Image from "../../assets/login/login.webp";
import Image_LQ from "../../assets/login/login_lq.webp";

const SignIn = () => {
  return (
    <div className="w-full max-w-[516px] bg-white/80 p-6 rounded-[20px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)]">
      <SignInForm />
    </div>
  );
};

export default SignIn;
